import * as React from "react";
import * as ReactDOM from "react-dom";
// import { Link } from "react-router-dom";
import SearchBoxDebounced from "../../components/SearchBoxDebounced";
import { convertUnixToDate } from "../../utils/datetime";
const algoliasearch = require("algoliasearch/lite");
const qs = require("qs");

import {
	InstantSearch,
	Hits,
	Highlight,
	Snippet,
	RefinementList,
	NumericMenu,
	Stats,
	Pagination,
	Configure,
	HierarchicalMenu,
	ClearRefinements,
	Menu,

	connectCurrentRefinements,
	connectRefinementList,
	connectNumericMenu,
	connectHierarchicalMenu,
	connectStateResults,
	connectMenu,
	connectHighlight,
	connectHits,
	connectHitInsights
} from "react-instantsearch-dom";

interface ResultProps {
	isSaved?: boolean;

	insights: (eventID: string, { eventName: string }) => void,

	hit: {
		objectID;
		name: string;
		slug: string;
		description?: string;
		url?: string;
		logo?: string;
		type?: string;
		_highlightResult: {
			name: {
				value: string;
			}
		}
		_snippetResult: {
			description: {
				value: string;
			}
		}
	}
}

interface ResultState {
}

const Snippet = ({ highlight, attribute, hit }) => {
	const parsedHit = highlight({
		highlightProperty: '_snippetResult',
		attribute,
		hit,
	});

	return (
		<div className="f6 black-80 lh-copy">
		{parsedHit.map(
			(part, index) =>
			part.isHighlighted ? (
				<span className="fw6" key={index} dangerouslySetInnerHTML={{
					__html: part.value
				}} />
			) : (
				<span key={index} dangerouslySetInnerHTML={{
					__html: part.value
				}} />
			)
		)}
		</div>
	);
};

const CustomSnippet = connectHighlight(Snippet);


class ResultRaw extends React.Component<ResultProps, ResultState> {
	render() {
		const hit = this.props.hit;
		let isExternalLink = false;
		let courseClickEvent = () => {
			this.props.insights("clickedObjectIDsAfterSearch", { eventName: "Course Clicked" });
		};

		let providerClickEvent = () => {
			this.props.insights("clickedObjectIDsAfterSearch", { eventName: "Provider Clicked" });
		}

		if ((hit as any).isPromoted) {
			isExternalLink = !hit.url?.includes("studyspy.ac.nz");

			courseClickEvent = () => {
				navigator.sendBeacon((hit as any).clickTrackingLink);
			};

			providerClickEvent = () => {
				navigator.sendBeacon((hit as any).clickTrackingLink);
			};
		}

		return (
			<div className="flex flex-column h-100" style={{ justifyContent: "space-between" }}>
				<div>
					<div className="dt w-100">
						<h2 className="dtc w-90 ma0 fw5 v-top mt2">
							<a className="db mh3 link underline-hover brand-font" href={`/providers/${hit.objectID}/${hit.slug}`} style={{ fontSize: 19, lineHeight: 1.3, fontWeight: 600 }}>
								{hit.name}
							</a>
						</h2>
					</div>

					{(hit as any).isPromoted &&
						<div
							title={(hit as any).score}
							className="default f7 ttu tc dib lh-solid br2 mt2 black-50 bg-black-05 ph2 pv1 ml3"
						>
							Promoted
						</div>
					}

					<div className="dt w-100" style={{ height: "72px" }}>
						{hit.logo &&
							<div className="dtc v-mid pa2 pl3" style={{ width: "48px" }}>
								<a className="br2 bg-white pa1 ba b--black-05 db" href={hit.url} target={isExternalLink ? "_blank" : undefined}>
									<div className="center tc flex items-center justify-center" style={{ width: "42px", height: "42px" }}>
										<img src={hit.logo} alt="" style={{ maxHeight: "42px", maxWidth: "42px" }} />
									</div>
								</a>
							</div>
						}
						<div className={`dtc pa3 ${hit.logo ? "pl2" : "pl3" }`}>
							<a href={hit.url} target={isExternalLink ? "_blank" : undefined}>
								<h3 className="mt1 dib f6 fw5 black-80 lh-title mb0">
									{hit.type}
								</h3>
							</a>
						</div>
					</div>

					<div className="bt b--black-05 mh3" />

					<div className="ma3 pv2">
						<CustomSnippet attribute="description" hit={hit} />
					</div>

					{!!((hit as any).isPromoted) &&
						<a
							href={(hit as any).url}
							style={{ marginTop: "auto" }}
							className="db link white bg-brand-blue mh3 mb3 ph3 pv2 br2 tc dim"
							onClick={courseClickEvent}
							target={isExternalLink ? "_blank" : undefined}
						>
							Learn more
						</a>
					}

					{/* Tracking pixel */}
					{!!(hit as any).viewTrackingPixel &&
						<img src={(hit as any).viewTrackingPixel} width="1" height="1" alt="" />
					}
				</div>
			</div>
		);
	}
}

const Result = connectHitInsights((window as any).aa)(ResultRaw);

interface FilterProps {
	label: string;
	refine?(x?);
	isRefined: boolean;
	currentRefinement?: string[] | string;
	canRefine?: boolean;
	items?: {
		count: number;
		isRefined: boolean;
		label: string;
		value: any; // probably an array
	}[];
	clear(x?);
}

interface FilterState {
	isOpen: boolean;
}

class Filter extends React.Component<FilterProps, FilterState> {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	open = () => {
		this.setState({ isOpen: true });
		document.body.classList.add("modal-open");
	}

	close = () => {
		this.setState({ isOpen: false });
		document.body.classList.remove("modal-open");
	}

	render() {
		const canRefine = this.props.canRefine;

		return (
			<div className="dib mr2 mt2">
				<div
					className={`${canRefine ? "pointer" : "black-50" } dt w-100 brand-font ba b--black-10 f6 ${this.props.isRefined ? "bg-brand-blue white" : "bg-white black-80"}`}
					onClick={canRefine ? this.open : () => {}}
					style={{ borderRadius: "4px" }}
				>
					<div className={`ma2 dtc v-mid ${canRefine ? "dim" : ""} ${this.props.isRefined ? "ph2" : "pa2"}`}>
						{this.props.label}
					</div>

					{this.props.isRefined &&
						<button
							className="b--white-10 dtc bg-transparent dim v-mid pa2 br2 white-90 pointer"
							style={{ width: "32px", height: "100%", borderStyle: "none none none solid", borderWidth: "1px" }}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								this.props.clear();
								// blur target, select X or view results?
							}}
						>
							<svg
								focusable="false"
								aria-label="Close"
								viewBox="0 0 32 32"
								width="14"
								height="14"
								fill="none"
								stroke="currentcolor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								style={{
									marginTop: "1px",
									marginBottom: "-2px"
								}}
							>
								<path d="M2 30 L30 2 M30 30 L2 2" />
							</svg>
						</button>
					}
				</div>
				{ReactDOM.createPortal(
					<div className="modal" style={{ display: this.state.isOpen ? "block" : "none" }}>
						<div
							className="modal__internals"
							aria-hidden="true"
							role="dialog"
							tabIndex={-1}
						>
							<div className="modal__body">
								<div className="modal__header">
									<div className="modal__close">
										<button
											className="modal__close__button"
											onClick={this.close}
										>
											<svg
												focusable="false"
												aria-label="Close"
												viewBox="0 0 32 32"
												width="15"
												height="15"
												fill="none"
												stroke="currentcolor"
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth="2"
											>
												<path d="M2 30 L30 2 M30 30 L2 2" />
											</svg>
										</button>
									</div>
									{this.props.isRefined &&
										<div className="modal__clear">
											<div className="modal__clear__internal">
												<button
													type="button"
													className="modal__clear__internal__button brand-blue"
													onClick={() => this.props.clear()}
												>
													<span>Clear</span>
												</button>
											</div>
										</div>
									}
								</div>

								<div className="modal__scroll">
									{this.props.children}
								</div>
							</div>

							<div className="modal__footer">
								<button
									type="button"
									className="modal__footer__button"
									onClick={this.close}
								>
									<span>View results</span>
								</button>
							</div>
						</div>
					</div>,
					document.getElementById("modal-container")
				)}
			</div>
		);
	}
}

/* REGION FILTER */
let RegionFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Location";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Locations (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

RegionFilter = connectRefinementList(RegionFilter);
/* REGION FILTER */


/* STUDY LEVEL FILTER *
let StudyLevelFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Study level";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Study levels (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

StudyLevelFilter = connectRefinementList(StudyLevelFilter);
/* STUDY LEVEL FILTER */


/* DOMESTIC/INTL FILTER *
let DomesticIntlFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Domestic/international";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

DomesticIntlFilter = connectRefinementList(DomesticIntlFilter);
/* DOMESTIC/INTL FILTER */

/* PROVIDER TYPE FILTER */
let ProviderTypeFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Provider type";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Types (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

ProviderTypeFilter = connectRefinementList(ProviderTypeFilter);
/* PROVIDER TYPE FILTER */

interface FiltersProps { }
interface FiltersState { }

class Filters extends React.Component<FiltersProps, FiltersState> {
	render() {

		//<RegionFilter attribute="eligibleRegions" />
		//<StudyLevelFilter attribute="studyLevels" />
		//<ProviderFilter attribute="providerName" />
		//{<EthnicityFilter attribute="eligibleEthnicities" />}
		//{<DomesticIntlFilter attribute="domesticOrInternational" />}

		return (
			<div className="search__filter-bar cf">
				<div className="search__filter-bar__content mw9-l center">
					<ProviderTypeFilter attribute="type" />
					<RegionFilter attribute="regions" />
				</div>
				<div className="search__filter-bar__blur" />
			</div>
		);
	}
}

const ConnectedFilters = connectCurrentRefinements(Filters);

const appId = window["__SEARCH_CONFIGURATION__"].appId;
const apiKey = window["__SEARCH_CONFIGURATION__"].apiKey;
const indexName = "providers";

/** AD CAMPAIGN PROMOTIONS **/
const promotions = window["__SEARCH_CONFIGURATION__"].promotions;
let adCampaignsPromotions;
let hitCountPromotion = 12; // 12 hits (default) if no promotion matches.
if (!!promotions) {
	promotions.sort((a, b) => b.priority - a.priority);
	adCampaignsPromotions = promotions.map(promotion => {
		return {
			keywords: promotion.keywords,
			negativeKeywords: promotion.negativeKeywords,
			promotionData: {
				id: promotion.id,
				objectID: promotion.id.toString(),
				providerId: promotion.providerId,
				providedBy: promotion.providerName,
				providerName: promotion.providerName,
				type: promotion.providerType,
				providerUrl: promotion.providerUrl,
				logo: promotion.providerLogo,
				isPromoted: true,
				name: promotion.name,
				description: promotion.description,
				url: promotion.url,
				viewTrackingPixel: promotion.viewTrackingPixel,
				clickTrackingLink: promotion.clickTrackingLink,
				_snippetResult: {
					description: {
						value: promotion.description,
					},
				}
			}
		};
	});
}
/** END AD CAMPAIGN PROMOTIONS **/

// We do this so we can inject promoted courses in, without having to
// pay thousands of dollars to do more than 10.
const ConnectedHits =  connectHits(({ hits, searchState }) => {
	const { query } = searchState;

	// AD CAMPAIGN PROMOTIONS
	if (!!adCampaignsPromotions) {
		adCampaignsPromotions.forEach(promotion => {
			let matchTick = 0;
			let queryWords = (query || "").toLowerCase().split(" ");
			let existsKeywords = promotion.keywords.some(keyword => {
				let keywordWords = keyword.toLowerCase().split(" ");
				return keywordWords.every(word => queryWords.includes(word));
			});
			let existsInNegative = promotion.negativeKeywords.some(negativeKeyword => {
				let negativeKeywordWords = negativeKeyword.toLowerCase().split(" ");
				return negativeKeywordWords.every(word => queryWords.includes(word));
			});

			if (existsKeywords && !existsInNegative) {
				matchTick++;
				hits = [
					...promotion.promotionData,
					...hits
				];
			}
			hitCountPromotion = 12 - matchTick;
		});
	}
	// END AD CAMPAIGN PROMOTIONS

	return (
		<div className="ais-Hits">
			<ul className="ais-Hits-list">
				{hits.map(hit =>
					<li
						className={`ais-Hits-item ${hit.isPromoted ? "ais-Hits-item--promoted" : ""}`}
						key={hit.objectID + (hit.isPromoted ? "-ad" : "")}
					>
						<Result hit={hit} />
					</li>
				)}
			</ul>
		</div>
	);
});

const Results = connectStateResults(({
	 searchState,
	 searchResults,
	 searching,
	 allSearchResults
 }) => {
	const hasResults = searchResults && searchResults.nbHits !== 0;
	const promoted: string[] = [];

	// So we can highlight the promoted courses (data isn't attached to the result)
	if (allSearchResults && allSearchResults.userData) {
		allSearchResults.userData.map(datum => {
			if (datum.promoted) {
				promoted.push(datum.promoted);
			}
		});
	}

	const FilterHelper = connectCurrentRefinements((props) => props.items.length ? <div>
		<p className="mh3 mt0 lh-copy black-60">
			Try clearing your filters to widen your search.
		</p>
		<ClearRefinements />
	</div>: null);

	if (hasResults) {
		// Force a recalculation of the web widget location
		if ((window as any).handleScroll) (window as any).handleScroll();

		return (
			<div className="mw9-l center ph2-l pb4">
				<Stats translations={{
					stats: (n, _ms) => {
						let result = `${n > 0 ? n.toLocaleString('en-NZ') : "No"} result${n == 1 ? "" : "s"}`

						if (searchState && searchState.query && searchState.query.length > 0) {
							result += ` for "${searchState.query}"`;
						}

						return result;
					}
				}} />

				<ConnectedHits
					searchState={searchState}
					promoted={promoted}
				/>

				<Pagination
					showLast={true}
					showFirst={true}
					padding={2}
					translations={{
						previous: "Previous",
						next: "Next",
					}}
				/>
			</div>
		);
	}
	else if (!searching) {
		return (
			<div className="tc pv4 pv5-l">
				<div className="f2">🤔</div>
				<div className="brand-font f3 lh-titl mt2">No results</div>
				<p className="measure-wide center db lh-copy black-60 mt2 tc ph3 mb0">
					We couldn't find anything{searchState.query && " for \"" + searchState.query + "\""}.
				</p>

				<FilterHelper />
			</div>
		);
	}
	else {
		return (
			<div className="tc pv4 pv5-l">
				<div className="brand-font f3 lh-titl mt2">Searching...</div>
			</div>
		);
	}
});

const createUrl = state => {
	if (!state) {
		return null;
	}

	return `?${qs.stringify(state, {
		skipNulls: true,
		strictNullHandling: true,
		filter: (prefix, value) => {
			if (prefix === "configure") {
				return;
			}

			return value;
		}
	})}`;
};

const searchStateToUrl = (props, searchState) => {
	// TODO: encode tag and location correctly

	if (searchState) {
		return `${props.location.pathname}${createUrl(searchState)}`;
	}

	return null;
};

const urlToSearchState = props => {
	let searchState = qs.parse(location.search.slice(1));

	if (props.match.params.tag) {
		// turn the tag query into an algolia-friendly query parameter
		// OR virtualmenu
	}

	if (!props.location || !props.location.search || !props.location.search.slice(1)) {
		return {};
	}

	return searchState;
}

interface SearchProps {
	location;
	history;
	match;
}

interface SearchState {
	searchState;
	showHero?: boolean;
}

export default class ProviderSearch extends React.Component<SearchProps, SearchState> {
	private debouncedSetState;
	private searchClient;

	constructor(props) {
		super(props);

		const searchState = urlToSearchState(props);

		let urlParams = new URLSearchParams(window.location.search);
		let hasQuery = urlParams.has('query');
		let isMobile = window.matchMedia("(max-width: 480px)").matches;

		this.state = {
			searchState,
			showHero: (!(isMobile || hasQuery)),
		};

		this.searchClient = algoliasearch(appId, apiKey);
	}

	componentWillReceiveProps(props) {
		if (props.location !== this.props.location) {
			this.setState({ searchState: urlToSearchState(props) });
		}
	}

	onSearchStateChange = searchState => {
		clearTimeout(this.debouncedSetState);

		this.debouncedSetState = setTimeout(() => {
			this.props.history.push(
				searchStateToUrl(this.props, searchState),
				searchState
			);
		}, 700);

		window.scrollTo(0, 0);
		this.setState({ searchState });
	}

	handleSubmit = query => {
		if (query) {
			// Permanently hidden if user submits a query.
			this.setState({ showHero: false }, () => {
				// Restore the query
				console.log(this.searchClient);
			});
		}
	}

	render() {
		const searchQuery = this.state.searchState.query ? `?query=${this.state.searchState.query}` : null;
		const heroImage = "https://ucarecdn.com/bb4735fb-a80e-45f8-920b-cfba88101181/";

		return (
			<InstantSearch
				searchClient={this.searchClient}
				indexName={indexName}
				searchState={this.state.searchState}
				onSearchStateChange={this.onSearchStateChange}
				createURL={createUrl}
			>
				<Configure hitsPerPage={12} />

				{this.state.showHero ? (
					<div className="bg-white">
						<div className="center pa3 pv5-ns mw9-l">
							<div className="flex flex-column-reverse dt-ns w-100">
								<div className="dtc v-mid w-66-ns">
									<h1 className="brand-font tc tl-ns fw7 lh-title f3 f1-ns mb0 brand-accent mt0">
										Find a provider.
									</h1>
									<p className="lh-copy tc tl-ns black-90 measure mt2 f5 f4-ns brand-font">
										Search for every tertiary education provider in New Zealand &ndash; universities,
										polytechs, PTEs, and more.
									</p>

									<div className="tailwind">
										<div className="w-full">
											<SearchBoxDebounced
												delay={200}
												autoFocus
												showLoadingIndicator
												showButton
												placeholder="Search providers..."
												translations={{ placeholder: "Search providers..." }}
												onSubmit={this.handleSubmit}
												onChange={() => window.scrollTo(0, 0)}
											/>
										</div>
									</div>
								</div>
								<div className="db dtc-ns v-mid w-60 w-40-ns center tc tr-ns">
									<picture>
										<img src={heroImage}
											alt=""
											className="dib"
											style={{ maxWidth: "100%", maxHeight: "300px" }}
											srcSet={`${heroImage}-/resize/x320/-/format/jpg/-/quality/lighter/ 320w,
													${heroImage}-/resize/x450/-/format/jpg/-/quality/lighter/ 450w,
													${heroImage}-/resize/x640/-/format/jpg/-/quality/lighter/ 640w,
													${heroImage}-/resize/x750/-/format/jpg/-/quality/lighter/ 750w,
													${heroImage}-/resize/x800/-/format/jpg/-/quality/lighter/ 800w,
													${heroImage}-/resize/x900/-/format/jpg/-/quality/lighter/ 900w,
													${heroImage}-/resize/x1000/-/format/jpg/-/quality/lighter/ 1000w,
													${heroImage}-/resize/x1200/-/format/jpg/-/quality/lighter/ 1200w`}
											sizes="(min-width: 1000px) 50vw, 100vw" />
									</picture>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="tailwind">
						{ReactDOM.createPortal(
							<SearchBoxDebounced
								delay={200}
								autoFocus
								showLoadingIndicator
								placeholder="Search providers..."
								onSubmit={this.handleSubmit}
								translations={{placeholder: "Search providers..."}}
								onChange={() => window.scrollTo(0, 0)}
							/>,
							document.getElementById("search-box-portal")
						)}
					</div>
				)}

				<div className="search__header">
					<ConnectedFilters />
				</div>

				<Menu attribute="tags" />

				<Results />
			</InstantSearch>
		);
	}
}
